import React from 'react'
import { Modal } from 'react-bootstrap'
import "./notificationModal.scss"
import Button from '../Button/Button';

interface NotificationModalProps {
  show: boolean;
  notificationHide: () => void;
  notificationtitle?: string;
  notificationtext?: string;
  submitButtonText?: string;
  cancelButtonText?: string;
  notificationOk: () => void;
}

const NotificationModal: React.FC<NotificationModalProps> = ({ notificationHide, notificationOk, ...props }) => {
  return (
    <Modal
      {...props}
      aria-labelledby="notification-modal"
      centered
      // size=""
      onHide={notificationHide}
      className='notification-modal'
    >
      <Modal.Body>
        <div className='notification-wrapper'>
          <h3 className='notification-title'>{props.notificationtitle}</h3>
          <p className='notification-description'>
            {props.notificationtext}
          </p>
        </div>
        <div className='notification-btn-box'>
          <div className="row gx-2">
            <div className="col-6">
              <Button btnText={props.cancelButtonText || 'Cancel'} className='btn-secondary' onClick={() => { notificationHide() }} />
            </div>
            <div className="col-6">
              <Button btnText={props.submitButtonText || 'Delete'} onClick={() => notificationOk()} />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default NotificationModal